import styles from "./styles.module.css";
import { useEffect, useState, useContext } from "react";
import { db } from "../../../firebase";
import { Select, Option } from "../../../select";
import Feature from "./features.js";
import { PluginsDisbatch } from "../../../contexts/plugins";
import Settings from "./settings";

export default function PluginEditor({ plugin, setPlugin }) {
  const [schema, setSchema] = useState(null);
  const disbatch = useContext(PluginsDisbatch);
  useEffect(() => {
    if (plugin.plugin) {
      db.collection("plugins")
        .doc(plugin.plugin.name)
        .get()
        .then((doc) => {
          console.log(doc.data());
          setSchema({ ...doc.data(), id: doc.id });
        });
    }
  }, [plugin.plugin]);

  const handleVersionChange = (version) => {
    disbatch({
      type: "setVersion",
      plugin: plugin.id,
      version: version,
    });
  };

  const handleSettingsChange = (config) => {
    disbatch({
      type: "setConfig",
      plugin: plugin.id,
      config: config,
    });
  };

  if (!schema) {
    return null;
  }

  return (
    <div className={styles.canvas}>
      <div className={styles.content}>
        <div style={{ display: "flex", alignItems: "center" }}>
          <div className={styles.pluginTitle}>{plugin.plugin.displayName}</div>
          <div>
            <div className={styles.text}>Version</div>
            <Select onChange={handleVersionChange} value={plugin.version}>
              {schema.versions.map((v) => {
                return (
                  <Option key={v} value={v}>
                    {v}
                  </Option>
                );
              })}
            </Select>
          </div>
        </div>
        <div className={styles.title}>Settings</div>
        <Settings
          config={plugin.config}
          onChange={handleSettingsChange}
          schema={plugin.plugin.config}
        />
        <div className={styles.title}>Plugin Features</div>

        {["components", "actions", "utilities", "apis"].map((section) => {
          return (
            <Feature
              key={section}
              section={section}
              items={plugin.plugin[section]}
            />
          );
        })}
      </div>
    </div>
  );
}
